import { VDBText } from "@components/atoms";
import { useTypographyStore } from "@redux/slices/typographySlice";
import * as Updates from "expo-updates";
import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components/native";
import styled from "styled-components/native";

const Footer = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const typography = useTypographyStore();
  return (
    <Container>
      <VDBText>
        {t("appVersion.title.text")} {Updates.runtimeVersion} (
        {process.env.EXPO_PUBLIC_BUILD_DATE}) {t("appVersion.rights.text")}
      </VDBText>
      <PoweredVDBContainer>
        <VDBText color={theme["core-06"]} style={typography["Minor-R"]}>
          {t("global.text.powerdBy")}
        </VDBText>
      </PoweredVDBContainer>
    </Container>
  );
};

const PoweredVDBContainer = styled.View`
  padding-top: 10px;
`;

const Container = styled.View`
  align-items: center;
`;

export default Footer;
